export { TabsModule } from './tabs.module';
export { TabsComponent } from './tabs.component';
export { ITabs } from './i-tabs';
